import { type HighlightsController } from '@databases/highlights';
import { createFillPreviewEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FillPreviewEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFillPreviewEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_PREVIEW_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE && ctx.permissions.canEditContent,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFillPreviewEffect(highlightsController);
    },
  };
}
